<template>
  <div class="landing-wrapper">
    <Breadcrumb v-if="breadcrumbs && breadcrumbs.length" :config="{ items: breadcrumbs }" />
    <div :class="['cmp__wrap', (bImg || sImg) ? 'bg-image' : '']"
      :style="{ backgroundImage: `url(${winW >= 768 ? bImg : sImg})` }">
      <template v-if="nodes && nodes.length">
        <component v-for="(node, index) in nodes" :key="index" :is="node.tag" :config="node" @load="onItemLoad">
        </component>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import utils from "@/utils";
import types from '@/store/types';

// 渲染由 CMS 发布的页面
export default {
  name: "LandingPage",
  components: {
    Breadcrumb: () => import('@/components/Breadcrumb'),
    // 文本和图标组件
    IconTitle: () => import('@/components/IconTitle'),
    IconTitleYellow: () => import('@/components/IconTitleYellow'),
    Txt: () => import('@/components/BigText'),
    TxtSimple: () => import('@/components/TxtSimple'),
    MultiLineText: () => import('@/components/MultiLineText'),
    BlankSpace: () => import('@/components/BlankSpace'),
    // 图片组件
    XImage: () => import('@/components/XImage'),
    CouponImage: () => import('@/components/XImage'),
    BannerImage: () => import('@/components/ImageBanner'),
    Image2text: () => import('@/components/Image2text'),
    MultiImageProduct: () => import('@/components/MultiImageProduct'),
    MultiImageProductHigh: () => import('@/components/MultiImageProductHigh'),
    MultiImageIcon: () => import('@/components/MultiImageIcon'),
    ImageFlex: () => import('@/components/ImageFlex'),
    ImageFlexHair: () => import('@/components/ImageFlexHair'),
    ImageFlexRight: () => import('@/components/ImageFlexRight'),
    ImageFlexImage: () => import('@/components/ImageFlexImage'),
    ImageFlexSimple: () => import('@/components/ImageFlexSimple'),
    ImageFlexUnlimited: () => import('@/components/ImageFlexUnlimited'),
    MultiImage: () => import('@/components/MultiImage'),
    VideoHome: () => import('@/components/VideoHome'),
    XVideo: () => import('@/components/XVideo'),
    // 轮播组件
    Swiper: () => import('@/components/ImageSwiper'),
    BaseSwiper: () => import('@/components/BaseSwiper'),
    MultiImageProductSwiper: () => import('@/components/MultiImageProductSwiper'),
    ProductSwiper: () => import('@/components/ProductSwiper'),
    ImageOnTextSwiper: () => import('@/components/ImageOnTextSwiper'),
    XSwiper: () => import('@/components/XSwiper'),
    // 动画组件
    InTextAnimate: () => import('@/components/InTextAnimate'),
    InTextAnimateMiddle: () => import('@/components/InTextAnimateMiddle'),
    InVideoAnimate: () => import('@/components/InVideoAnimate'),
    // 商品组件
    CategoryList: () => import('@/components/CategoryList'),
    ProductRecommend: () => import('@/components/ProductRecommend'),
    MultiImageProductRecommend: () => import('@/components/MultiImageProductRecommend'),
    // 其他组件
    TrialByPostModal: () => import('@/components/TrialByPostModal'),
    OfflineAppointmentPc: () => import('@/components/OfflineAppointmentPc'),
    OfflineAppointmentWechat: () => import('@/components/DefaultPlugin'),
    AnchorPoint: () => import('@/components/AnchorPoint')
  },
  data() {
    return {
      breadcrumbs: [],
      nodes: [],
      bImg: '',
      sImg: '',
      imgLoadedCount: 0,
      enableAnchor: false
    };
  },
  created() {
    this.getUrlFroJump()
    this.$route.meta.loaded = false;
    let { key, url } = this.$route.query;
    if (key) {
      this.$store.dispatch(types.GET_PROFILE)
      this.init(key);
    } else if (!url) {
      this.$router.replace("/");
      return
    }
    if (this.$route.hash) {
      this.enableAnchor = true;
    }
  },
  mounted() { },
  methods: {
    getUrlFroJump() {
      let path = this.$route.query?.url;
      console.log("即将跳转到微信小程序端", this.$route.query);
      if (path) {
        api[types.MIN_PROGRAMN]({ path: path }).then(res => {
          if (res.message) {
            console.log("AAA")
            window.location.href = res.message;
          }
        });
      }
    },
    init(key) {
      api.ajax4Page(key).then(res => {
        let { key, title, nodes, type, breadcrumbs, bg_big_image, bg_small_image, desciption, keyword, status } = res;
        if (status != 1) return this.$router.push({ path: '/landing?key=campaign' });
        this.nodes = []
        // 切换站点导航及Footer
        if (['main_website', 'hair_website'].indexOf(type) != -1) {
          this.$store.commit('toggleNavType', type == 'main_website');
        }
        // 页面信息处理
        title && utils.setPageInfo(`${title}`, {
          keywords: keyword || [title, key].join(","),
          description: desciption || title
        });
        // 页面组件
        if (Array.isArray(nodes) && nodes.length) {
          // 付邮试用节点查找
          let trialImage = nodes.find(node => node.tag == "XImage" && node.action?.route?.pageKey == "trial_by_post");
          let trialModal = nodes.findIndex(node => node.tag == "TrialByPostModal");
          // 付邮试用特殊节点处理
          if (trialImage && trialModal != -1) {
            trialImage.tag = "TrialByPostModal";
            trialImage.name = "付邮试用复合组件";
            nodes.splice(trialModal, 1);
          }
          // 
          this._imgCount = this._imgCount || 0;
          nodes.forEach(node => {
            if (node.tag == 'XImage') {
              this._imgCount += 1;
            } else if (node.tag == "MultiImageProductRecommend") {
              this._imgCount += node.nodes.length;
            } else if (node.tag == "ProductRecommend") {
              this._imgCount += node.nodes.length;
            }
          });
          // console.log(this._imgCount);
          this.nodes = nodes;
        }
        // 背景图处理
        if (bg_big_image) {
          this.bImg = bg_big_image;
          this.sImg = bg_small_image || bg_big_image;
        }
        // 面包屑处理
        if (breadcrumbs) {
          if (typeof breadcrumbs == "string") {
            try {
              breadcrumbs = JSON.parse(breadcrumbs);
            } catch (err) {
              breadcrumbs = [];
              console.warn('[info]:: 面包屑解析失败');
            }
          }
          this.breadcrumbs = breadcrumbs.map(item => {
            return { text: item.name, href: item.url.replace(`${location.protocol}//${location.host}`, '') };
          });
        }
      }).catch(err => {
        console.warn(err);
        if (this.pageKeyNotFound) {
          location.href = this.pageKeyNotFound;
        } else {
          this.$router.push({ path: '/landing?key=campaign' });
        }
      });
    },
    onItemLoad(target) {
      // eslint-disable-next-line no-unused-vars
      let { src, type, platform } = target;
      if (['image'].indexOf(type) != -1) {
        this.imgLoadedCount += 1;
      }
      // 图片加载完
      if (Math.abs(this._imgCount - this.imgLoadedCount) < 2) {
        // 
        this.$route.meta.loaded = true;
        // 启用Hash锚点定位
        this.enableAnchor && !this.__anchored__ && this.scrollToAnchor();
      }
    },
    scrollToAnchor() {
      var anchor = this.$el.querySelector(this.$route.hash);
      if (anchor) {
        let st = anchor.offsetTop;
        // 减掉导航高度（37像素误差来源未知）
        window.scrollTo(0, st + 156 - 70 + 37 - 100);
        this.__anchored__ = true;
        // 
        // document.documentElement.scrollTop = st;
        // document.body.scrollTop = st;
        // 耗时, 频率, 高度
        // var duration = 500, interval = 1000/60, st = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        // var step = (st / duration) * interval;
        // var timer = setInterval(() => {
        //   let currST = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        //   if (currST === 0) {
        //     console.info('[info]:: clearInterval');
        //     timer && clearInterval(timer);
        //     return;
        //   }
        //   currST -= step;
        //   document.documentElement.scrollTop = currST;
        //   document.body.scrollTop = currST;
        // }, interval);
      } else {
        console.info('锚点不存在: ', this.$route.hash);
      }
    }
  },
  computed: {
    winW() {
      return window.innerWidth;
    },
    pageKeyNotFound() {
      if (this.$store.state.siteConfig) {
        const { NOT_FOUND } = this.$store.state.siteConfig;
        if (NOT_FOUND && NOT_FOUND.value) {
          try {
            NOT_FOUND.value = JSON.parse(NOT_FOUND.value);
            const { pc, mob } = NOT_FOUND.value;
            return utils.isMobile() ? mob : pc;
          } catch (err) {
            console.warn('@Footer.computed#404跳转链接解析异常::', err);
          }
          return "";
        }
        return "";
      }
      return "";
    }
  },
  watch: {
    $route(to) {
      let { key } = to.query;
      this.init(key);
    }
  }
};
</script>

<style lang="scss" scoped>
.landing-wrapper {
  box-sizing: border-box;

  .cmp__wrap {
    position: relative;
  }

  .bg-image {
    // background-image: url(../assets/imgs/bg/expert-diagnosis/expert-diagnosis-bg-mobile.png);
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0 auto;
    padding: 0 1rem;
  }
}

@media screen and (max-width: 47.9375em) {
  .landing-wrapper .cmp__wrap /deep/>.landing-banner {
    margin-top: 0;
  }
}

// @media screen and (min-width: 48em) {
//   .landing-wrapper {
//     .bg-image {
//       background-image: url(../assets/imgs/bg/expert-diagnosis/expert-diagnosis-bg-tablet.png);
//     }
//   }
// }

// @media screen and (min-width: 64em) {
//   .landing-wrapper {
//     .bg-image {
//       background-image: url(../assets/imgs/bg/expert-diagnosis/expert-diagnosis-bg-desktop.png);
//     }
//   }
// }</style>